export default __webpack_public_path__ + "static/media/27.4efc0f8f.jpg";